import React, { useEffect, useState, useRef } from 'react'
import { Grid, Typography } from '@mui/material'
import ReactGA from 'react-ga4'
import { useNavigate, useParams } from 'react-router-dom'
import { AppConstants } from 'AppConstants/AppConstants'
import Footer from 'components/Footer'
import Header from 'components/Header'
import TextField from 'components/shared/textField'
import { useAppDispatch, useAppSelector } from 'redux/store'
import { validateEmail } from 'utils/validateEmail'
import styles from './Name.module.scss'

const NameRegular: React.FC = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const [firstname, setFirstname] = useState('')
  const [email, setEmail] = useState('')
  const [disableBtn, setDisableBtn] = useState(true)
  const isMoreThanOneStudio = useAppSelector((state) => state.isMoreThanOneStudio.isMoreThanOneStudio)
  const emailRef = useRef<HTMLInputElement>(null)

  const onContinue = () => {
    if (firstname.length !== 0 && email.length !== 0 && validateEmail(email)) {
      localStorage.setItem(AppConstants.USER_FIRST_NAME, firstname)
      localStorage.setItem(AppConstants.USER_EMAIL, email)
      navigate('/login')
    }
  }

  useEffect(() => {
    if (id === 'google') {
      ReactGA.event('page_view', {
        page_title: 'Regular|Name',
        page_location: '/name',
      })
    }
  }, [id])

  useEffect(() => {
    if (id === 'facebook') {
      //@ts-ignore
      //  fbq('track', 'ViewContent')
    }
  }, [id])

  useEffect(() => {
    localStorage.setItem(AppConstants.USER_FIRST_NAME, '')
    localStorage.setItem(AppConstants.USER_EMAIL, '')
  }, [])

  useEffect(() => {
    // Enable button only if both firstname and email are filled and email is valid
    if (firstname.length > 0 && email.length > 0 && validateEmail(email)) {
      setDisableBtn(false)
    } else {
      setDisableBtn(true)
    }
  }, [firstname, email])

  return (
    <div className={styles.container}>
      <Header
        headerText={''}
        showBackButton={true}
        onBack={() => {
          navigate('/')
        }}
      ></Header>
      <div className={styles.content}>
        <div className={styles.textContainer}>
          <span>Let's get you scheduled</span>
          <br></br>
          <span>with our doctors. What's</span>
          <br></br>
          <span>your first name and email?</span>
        </div>
        <div className={styles.formContainer}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                autoFocus
                style={{ marginTop: '5px' }}
                sx={{
                  '& .MuiInputBase-input': {
                    textTransform: 'capitalize',
                  },
                  '@media (min-width:600px)': {
                    '& .MuiInputLabel-root.Mui-focused': {
                      height: '16px',
                    },
                  },
                }}
                placeholder="Enter first name"
                label="First Name"
                name="firstname"
                value={firstname}
                onChange={(e) => {
                  setFirstname(e.target.value)
                }}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault()
                    emailRef.current?.focus()
                  }
                }}
                className={styles.firstNameInput}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                inputRef={emailRef}
                style={{ marginTop: '5px' }}
                sx={{
                  '@media (min-width:600px)': {
                    '& .MuiInputLabel-root.Mui-focused': {
                      height: '16px',
                    },
                  },
                }}
                placeholder="Enter Email Address"
                label="Email"
                name="email"
                type="email"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value)
                }}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    disableBtn ? undefined : onContinue()
                  }
                }}
                className={styles.emailInput}
              />
            </Grid>
          </Grid>
        </div>
      </div>
      <Footer
        buttonText={'Continue'}
        isLoading={false}
        shouldShowFour={true}
        shouldShowFive={true}
        shouldShowSix={true}
        shouldShowSeven={isMoreThanOneStudio}
        trackerIndex={1}
        isDisabled={disableBtn}
        buttonId={'continue-btn'}
        buttonType={'button'}
        onButtonClick={() => {
          disableBtn ? undefined : onContinue()
        }}
      ></Footer>
    </div>
  )
}

export default NameRegular
